import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getInvoice, mapPaymentError } from '../../api/endpoints/payments';
import { InvoiceDocument } from './InvoiceDocument';
import { StoredInvoicePdf } from './StoredInvoicePdf';
import { PrintToolbar } from './PrintToolbar';
export function InvoicePrintView() {
  const { t } = useTranslation();
  const id = Number(useParams().invoiceId);
  const invoice = useQuery({
    queryKey: ['payments', 'invoice', id],
    queryFn: () => getInvoice(id),
    enabled: Number.isSafeInteger(id) && id > 0,
    retry: false,
  });
  if (!Number.isSafeInteger(id) || id <= 0)
    return <p role="alert">{t('invoices.invoicePrintView.invalidId')}</p>;
  if (invoice.isPending) return <p role="status">{t('invoices.invoicePrintView.loading')}</p>;
  if (invoice.isError)
    return (
      <p role="alert">
        {mapPaymentError(invoice.error)}{' '}
        <button onClick={() => invoice.refetch()}>{t('common.actions.retry')}</button>
      </p>
    );
  return (
    <main className="dnm-print-page">
      <PrintToolbar
        onDownload={async () => {
          const { downloadInvoicePdf } = await import('./invoicePdf');
          await downloadInvoicePdf(invoice.data);
        }}
        title={`${invoice.data.invoiceNumber} · DNM Logistics`}
      />
      <div className="dnm-print-toolbar">
        <StoredInvoicePdf invoice={invoice.data} />
      </div>
      <InvoiceDocument invoice={invoice.data} />
    </main>
  );
}
